import App from "./app";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/_app.scss";
import TermsAndConditions from "./pages/terms_and_conditions/terms_and_conditions";
import PrivacyPolicy from "./pages/privacy_policy/privacy_policy";
import Support from "./pages/support/support";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
      <Route path="/support" element={<Support />} />
    </Routes>
  </BrowserRouter>
);

